import { type FC } from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Icon, type IIconsVector, Typography } from 'shared/ui'
import { formatCallDuration } from 'shared/lib'
import styles from './styles.module.scss'

type ConversationCardCallProps = {
  iconVector: IIconsVector
  label: string
  duration?: number
  isTextDestructive?: boolean
  isIconDestructive?: boolean
  className?: string
}

export const ConversationCardCall: FC<ConversationCardCallProps> = observer(
  ({ iconVector, label, duration, isTextDestructive, isIconDestructive, className }) => {
    return (
      <div className={styles.wrap}>
        <Icon
          className={styles.icon}
          icon={iconVector}
          fontSize={16}
          color={
            isIconDestructive
              ? 'var(--content-negative-primary)'
              : 'var(--content-primary-secondary)'
          }
        />
        <Typography
          className={classnames(styles.label, className, {
            [styles.labelDestructive]: isTextDestructive,
          })}
          variant={'body-md-regular'}
          ellipsis
          ariaLabel={'label'}
        >
          {label}
        </Typography>
        {!!duration && (
          <span className={styles.duration}>{`· ${formatCallDuration(duration)}`}</span>
        )}
      </div>
    )
  }
)
